import { render } from "./NewOpportunities.vue?vue&type=template&id=3cd54fbf"
import script from "./NewOpportunities.vue?vue&type=script&lang=js"
export * from "./NewOpportunities.vue?vue&type=script&lang=js"

import "./NewOpportunities.vue?vue&type=style&index=0&id=3cd54fbf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__